<template>
  <div>
    <div
      class="w-full h-[200px] bg-[#F4F4F4] border border-[#E2E2E2] rounded-[8px] flex items-center justify-center overflow-hidden mb-[24px]"
      :class="disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'"
      :style="disabled && disabledBgColor ? { backgroundColor: disabledBgColor + ' !important' } : {}"
      @click="openFilePicker"
    >
      <img
        v-if="localPreviewUrl"
        :src="localPreviewUrl"
        class="w-full h-full object-cover"
        alt="Preview"
      >
      <img
        v-else
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/gallery-add.svg"
        alt="Upload Placeholder"
        class="size-[32px]"
      >
    </div>

    <div class="w-full flex items-center border border-dashed border-[#E2E2E2] rounded-[8px] px-[14px] py-[8px] gap-[8px]">
      <button
        type="button"
        class="flex items-center gap-[8px] border border-[#F95031] rounded-[6px] px-[8px] py-[6px] cursor-pointer hover:bg-[#FFEBE7] transition-colors"
        @click="openFilePicker"
      >
        <span class="k-document-upload text-[#F95031]" />
        <span class="text-[#F95031] font-semibold text-[12px]">Pilih Foto</span>
      </button>
      <span
        class="text-[14px] overflow-hidden text-ellipsis whitespace-nowrap"
        :class="hasFiles ? 'text-[#333]' : 'text-[#E2E2E2]'"
      >
        {{ displayFileName }}
      </span>
      <input
        ref="fileInput"
        type="file"
        :name="name"
        accept="image/jpeg,image/png"
        class="hidden"
        @change="handleFileChange"
      >
    </div>

    <p class="text-[#9E9E9E] text-[12px] mt-[8px] mb-0">
      Upload foto format JPG/PNG dengan max. 3 MB dan rasio 4:1
    </p>
  </div>
</template>

<script>
/**
 * Component to handle image uploads with preview capabilities.
 * Supports handling local files and displaying existing image URLs.
 */
export default {
  props: {
    value: { type: [Array, String, Object], default: () => [] },
    type: { type: String, default: 'IMAGE' },
    name: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    disabledBgColor: { type: String, default: '' },
  },
  data: () => ({ localPreviewUrl: null }),
  computed: {
    hasFiles() {
      return !!this.value && (!Array.isArray(this.value) || this.value.length > 0)
    },
    displayFileName() {
      if (!this.hasFiles) return 'Upload Foto'
      const files = Array.isArray(this.value) ? this.value : [this.value]
      return files.map(f => (typeof f === 'string' ? f.split('/').pop() : f?.name || 'File')).join(', ')
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.localPreviewUrl?.startsWith('blob:')) URL.revokeObjectURL(this.localPreviewUrl)
        const file = Array.isArray(val) ? val[0] : val
        let preview = null
        if (file instanceof File) {
          preview = URL.createObjectURL(file)
        } else if (typeof file === 'string') {
          preview = file
        }
        this.localPreviewUrl = preview
        if (!val || (Array.isArray(val) && val.length === 0)) {
          if (this.$refs.fileInput) this.$refs.fileInput.value = ''
        }
      },
    },
  },
  beforeDestroy() {
    if (this.localPreviewUrl?.startsWith('blob:')) URL.revokeObjectURL(this.localPreviewUrl)
  },
  methods: {
    openFilePicker() {
      if (this.disabled) return
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      if (e.target.files?.length) {
        const files = Array.from(e.target.files)
        this.$emit('input', files)
        this.$emit('change', files)
      }
      e.target.value = ''
    },
  },
}
</script>

<style scoped>
.is-invalid .border,
.is-invalid .border-dashed {
  border-color: #ea5455 !important;
}
</style>
